import { observer } from "mobx-react-lite";
import styles from "./ResetPasswordForm.module.scss";
import React from "react";
import MyButton from "../../../components/UI/MyButton/MyButton";
import MyInput from "../../../components/UI/MyInput/MyInput";

const ResetPasswordForm = () => {
  return <div></div>;
};

export default observer(ResetPasswordForm);
